import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Scoreboard from "./pages/Scoreboard";
import Nickname from "./components/Nickname";
import { TourProvider } from '@reactour/tour';

function App() {
  const hasNickname = !!localStorage.getItem("nickname");

  return (
    <TourProvider
      steps={[]} // defined in Home
      disableInteraction
      styles={{
        popover: (base) => ({
          ...base,
          backgroundColor: '#ffffff',
          color: '#2b3b4b',
          borderRadius: '12px',
          padding: '1.5rem',
          maxWidth: '360px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          fontFamily: 'Inter, sans-serif',
        }),
        close: (base) => ({
          ...base,
          color: '#f68d43',
        }),
        controls: (base) => ({
          ...base,
          marginTop: '1.5rem',
        }),
        buttonNext: (base) => ({
          ...base,
          backgroundColor: '#00aca9',
          color: 'white',
        }),
        buttonBack: (base) => ({
          ...base,
          color: '#2b3b4b',
        }),
      }}
    >
      <Router>
        <Routes>
          <Route
            path="/"
            element={hasNickname ? <Navigate to="/home" /> : <Nickname />}
          />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route
            path="/home"
            // ✅ THIS KEY FIXES THE REMOUNT!
            element={<Home key={localStorage.getItem("nickname") || "guest"} />}
          />
          <Route path="/scoreboard" element={<Scoreboard />} />
        </Routes>
      </Router>
    </TourProvider>
  );
}

export default App;
